import { Select } from '@base-ui/react/select'
import { twMerge } from 'tailwind-merge'
import { scrollArrowClass } from './scroll-arrow-class'

interface SelectScrollDownArrowProps {
  className?: string
}

function SelectScrollDownArrow({ className, ...props }: SelectScrollDownArrowProps) {
  return <Select.ScrollDownArrow className={twMerge(scrollArrowClass, className)} {...props} />
}

export { SelectScrollDownArrow }
